import { useEffect, useState } from "react";
import { apiGetExitLog, apiGetExits } from "../../../utils/api/api";
import { Accordion, AccordionDetails, AccordionSummary, CircularProgress, Divider } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { formatDateTime, toLocalePriceNoDecimal } from "../../../utils/StringUtil";

const ExitLog = ({ scheme, open, exitType }) => {

  const [isLoading, setIsLoading] = useState(false);
  const [exits, setExits] = useState([]);
  const [exitLog, setExitLog] = useState([]);
  const [expanded, setExpanded] = useState(null);
  const [isExitLogLoading, setIsExitLogLoading] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : null);
  };

  const getExits = (param = {}) => {
    param.oppRid = scheme.oppRid;
    param.exitType = exitType;
    setIsLoading(true);
    apiGetExits(param)
      .then((data) => {
        setIsLoading(false);
        setExits(data);
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
      });
  }

  const getExittLog = (param = {}) => {
    param.extRid = expanded;
    setIsExitLogLoading(true);
    apiGetExitLog(param)
      .then((data) => {
        setIsExitLogLoading(false);
        setExitLog(data);
      })
      .catch((error) => {
        setIsExitLogLoading(false);
        console.log(error);
      });
  }

  useEffect(() => {
    if (open) {
        setIsLoading(true);
      getExits();
    }
  }, [open, exitType]);

  useEffect(() => {
    if (expanded !== null) {
      getExittLog();
    }
  }, [expanded]);

  return (
       <div className="px-2">
            <table className="table table-borderless w-100 mb-0">
                <thead>
                    <tr className="fs-med-semibold text-center ">
                        <th className="text-start" style={{ width: "14%" }}>Exit Date</th>
                        <th className="text-end" style={{ width: "21%" }}>Total Gross Amount</th>
                        <th className="text-end" style={{ width: "21%" }}>Total Fee</th>
                        <th className="text-end" style={{ width: "14%" }}>Total TDS</th>
                        <th className="text-end" style={{ width: "14%" }}>Total Carry</th>
                        <th className="text-end" style={{ width: "17%" }}>Total Net Amount</th>
                    </tr>
                </thead>
            </table>

            {exits.length > 0 ? (
                exits.map((data) => {
                    return (
                        <div>
                            {isLoading ? <CircularProgress /> :
                                (
                                    <>

                                        <Accordion
                                            key={data.extRid}
                                            expanded={expanded === data.extRid}
                                            onChange={handleChange(data.extRid)}
                                            style={{
                                                border: "0.5px solid  #e0e0e0",
                                                borderRadius: "8px",
                                                boxShadow: "none",
                                                marginBottom: "2px",
                                            }}
                                        >

                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon color='primary' />}
                                                aria-controls={`panel-${data.pytRid}-content`}
                                                id={`panel-${data.pytRid}-header`}
                                                style={{ backgroundColor: "#F3EEF7" }}
                                            >

                                                <table className="w-100">
                                                    <tbody>
                                                        <tr className="fs-med-semibold text-center">
                                                            <td className="text-start" style={{ width: "14%" }}>
                                                                {data.exitDate ? formatDateTime(data.exitDate) : 'N/A'}
                                                            </td>
                                                            <td className="text-end" style={{ width: "21%" }}>{toLocalePriceNoDecimal(data.totalGrossAmount)}</td>
                                                            <td className="text-end" style={{ width: "21%" }}>{toLocalePriceNoDecimal(data.totalFee)}</td>
                                                            <td className="text-end" style={{ width: "15%" }}>{toLocalePriceNoDecimal(data.totalTds)}</td>
                                                            <td className="text-end" style={{ width: "15%" }}>{toLocalePriceNoDecimal(data?.totalCarry)}</td>
                                                            <td className="text-end" style={{ width: "17%" }}>{toLocalePriceNoDecimal(data.totalNetAmount)}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </AccordionSummary>
                                            <Divider />
                                            <AccordionDetails>
                                                {isExitLogLoading ? <CircularProgress /> : (
                                                    <>
                                                        {expanded === data.extRid && exitLog?.length > 0 ? (
                                                            <>
                                                                <table className="table table-striped table-borderless w-100 ">
                                                                    <thead>
                                                                        <tr className="fs-normal-semibold text-start">
                                                                            <th scope="col" style={{ width: "14%" }}>
                                                                                <p className="mb-2">Investor Name</p>
                                                                            </th>
                                                                            <th scope="col" style={{ width: "9%" }}><p className="mb-2 text-start p-0">Investor Code</p></th>
                                                                            <th scope="col" style={{ width: "12%" }}>
                                                                                <p className="mb-2 text-end" >Gross Amount</p>
                                                                            </th>
                                                                            <th scope="col" style={{ width: "12%" }}>
                                                                                <p className="mb-2 text-center" >Fee Type</p>
                                                                            </th>
                                                                            <th scope="col" style={{ width: "8%" }}>
                                                                                <p className="mb-2 text-end" >Fee</p>
                                                                            </th>
                                                                            <th scope="col" style={{ width: "15%" }}>
                                                                                <p className="mb-2 text-end">TDS</p>
                                                                            </th>
                                                                            <th scope="col" style={{ width: "15%" }}>
                                                                                <p className="mb-2 text-end">Carry</p>
                                                                            </th>
                                                                            <th scope="col" style={{ width: "18%" }}>
                                                                                <p className="mb-2 text-end" >Net Amount</p>
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {exitLog.map((data, key) => {
                                                                            return (
                                                                                <tr className="fs-normal-medium text-center" key={key}>

                                                                                    <td className="pt-3" style={{ width: "14%" }}>
                                                                                        <span style={{ whiteSpace: "nowrap" }}>
                                                                                            {data?.invName ?? ''}
                                                                                            {/* {data?.invCode && ` (${data.invCode})`} */}
                                                                                        </span>
                                                                                        <div className="fs-small-regular text-muted" style={{ display: "block" }}>{data?.className}</div>

                                                                                    </td>
                                                                                    <td className="pt-3 text-start" style={{ width: "9%" }} >{data?.invCode}</td>
                                                                                    <td className="pt-3 text-end" style={{ width: "12%" }}>{toLocalePriceNoDecimal(data.grossAmount)}</td>
                                                                                    <td className="pt-3 text-center" style={{ width: "12%" }}>{data?.feeType ? data.feeType : "---"}</td>
                                                                                    <td className="pt-3 text-end" style={{ width: "8%" }}>{data?.fee ? toLocalePriceNoDecimal(data.fee) : "---"}</td>
                                                                                    <td className="pt-3 text-end" style={{ width: "15%" }}>{data?.tds ? toLocalePriceNoDecimal(data.tds) : "---"}</td>
                                                                                    <td className="pt-3 text-end" style={{ width: "15%" }}>{data?.carry ? toLocalePriceNoDecimal(data.carry) : "---"}</td>
                                                                                    <td className="pt-3 text-end" style={{ width: "18%" }}>{toLocalePriceNoDecimal(data?.netAmount) ?? '---'} </td>
                                                                                </tr>
                                                                            );
                                                                        })}

                                                                    </tbody>
                                                                </table>
                                                            </>
                                                        ) : (
                                                            <div className="text-center p-4">No logs found.</div>)}
                                                    </>
                                                )}
                                            </AccordionDetails>
                                        </Accordion></>
                                )
                            }

                        </div>
                    )
                })
            ) : (
                <div className="text-center p-4">No Exits found.</div>
            )}
        </div>
  )

}

export default ExitLog;